import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Text, Flex } from '@qga/roo-ui/components';
import MapWithMarker from 'components/maps/MapWithMarker';
import GetDirections from 'components/maps/GetDirections';
import formatPropertyAddress from 'components/formatters/FormatPropertyAddress';
import { captureErrorInSentry } from 'lib/errors';
import { useSelector } from 'react-redux';
import { getBrowser } from 'store/userEnvironment/userEnvironmentSelectors';
import { isLegacyBrowser } from 'lib/browser/isLegacyBrowser';
import GoogleMapStaticImage from 'components/maps/GoogleMapStaticImage';

const Address = ({ address }) => (
  <Box fontSize="xs">
    {formatPropertyAddress({
      streetAddressLines: address.streetAddress,
      suburb: address.suburb,
      state: address.state,
      country: address.country,
    })}
  </Box>
);

Address.propTypes = {
  address: PropTypes.object.isRequired,
};

const PropertyInfo = ({ property }) => (
  <Flex flexDirection="column" mb={2}>
    <Text fontSize="base" fontWeight="bold">
      {property.name}
    </Text>
    <Address address={property.address} />
  </Flex>
);

PropertyInfo.propTypes = {
  property: PropTypes.object.isRequired,
};

const PropertyMap = ({ property }) => {
  const browser = useSelector(getBrowser);
  const displayStaticMap = isLegacyBrowser(browser?.name);

  const { latitude, longitude, name } = property;

  const [mapError, setMapError] = useState(undefined);
  useEffect(() => {
    if (mapError) {
      captureErrorInSentry(mapError);
    }
  }, [mapError]);

  return (
    <Box>
      {!mapError && !displayStaticMap && (
        <Box height={['300px', '400px']} width="100%" pb={6}>
          <MapWithMarker name="property-map" latitude={latitude} longitude={longitude} lazy onError={setMapError} />
        </Box>
      )}

      {displayStaticMap && (
        <GoogleMapStaticImage location={`${latitude},${longitude}`} locationName={name} width={[640, 800]} height={[300, 400]} markers />
      )}

      <PropertyInfo property={property} />
      <GetDirections address={property.address} />
    </Box>
  );
};

PropertyMap.propTypes = {
  property: PropTypes.object.isRequired,
};

export default PropertyMap;
